/**
 * Extra recording time (ms) kept rolling after a timed round's clock hits
 * zero, so the final pushups past the bell are captured instead of being cut
 * off the instant the time limit is reached.
 */
export const ROUND_END_RECORDING_TAIL_MS = 5_000;
